import { UpdateParenthoodVM } from 'mutation/view-models/update-parenthood';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<UpdateParenthoodVM, keyof UpdateParenthoodVM>[] = [
  {
    id: 'fiscalCode',
    label: 'Codice Fiscale',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'gender',
    label: 'Sesso',
  },
  {
    id: 'dateBirth',
    label: 'Data di nascita',
  },
  {
    id: 'placeBirth',
    label: 'Luogo di nascita',
  },
  {
    id: 'residence',
    label: 'Residenza',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'relationshipSelect',
    label: 'Parentela',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
